import { autoinject } from 'aurelia-framework';
import { tabRoutes } from './service-kpis-tab-routes';
import { RouterConfiguration } from 'aurelia-router';
import { TabManager } from 'views/admin/mooring/tab-manager';

@autoinject
export class ServiceKpis {
  constructor(private tabManager: TabManager) {}

  get tab() {
    return this.tabManager.currentTabIndex;
  }

  private configureRouter(config: RouterConfiguration) {
    config.map(tabRoutes);
  }
}
